import { render, staticRenderFns } from "./Transaksi.vue?vue&type=template&id=2b9a541a"
import script from "./Transaksi.vue?vue&type=script&lang=js"
export * from "./Transaksi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports